import ProjectInvoice from '../model/invoice/project-invoice';
import Product from '../model/product/product';
import { Project } from '../model/project/project';
import ProjectHelper from './project-helper';
import { OVERRIDES, PriceLine } from '../model/price-line';

export default class InvoiceHelper {
  static hasAdjustedProductPrice(invoice: ProjectInvoice, product: Product) {
    if (invoice != null) {
      if (invoice.priceLines != null) {
        for (let line of invoice.priceLines) {
          if (line.placementLine) {
            if (line.product != null) {
              if (line.product.id == product.id) {
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  }

  static getSendButtonLabel(
    numContacts: number,
    invoices: ProjectInvoice[]
  ): string {
    if (numContacts == 0 || invoices == null || invoices.length === 0) {
      return 'Verstuur factuur naar Teamleader';
    }
    if (numContacts === 1) {
      return invoices.findIndex(i => i.teamleaderId != null) < 0
        ? 'Verstuur factuur naar Teamleader'
        : 'Verstuur factuur opnieuw naar Teamleader';
    } else {
      return invoices.findIndex(i => i.teamleaderId != null) < 0
        ? 'Verstuur facturen naar Teamleader'
        : 'Verstuur facturen opnieuw naar Teamleader';
    }
  }

  static getAnySentToTeamleader(invoices: ProjectInvoice[]): boolean {
    return invoices.some(i => i.teamleaderId != null);
  }

  static getLinkText(invoice: ProjectInvoice) {
    return (
      'Factuur ' +
      invoice.company.regularName +
      (invoice.invoiceNumber != null && invoice.invoiceNumber !== ''
        ? ': ' + invoice.invoiceNumber
        : '')
    );
  }

  static getRepoPriceLinesFromBaseProject(
    project: Project,
    invoice: ProjectInvoice
  ): PriceLine[] {
    if (
      project.subProjects == null ||
      invoice.company == null ||
      invoice.company.id == null
    ) {
      return [];
    }
    const baseProject = ProjectHelper.getBaseProject(project);
    if (baseProject == null || baseProject.projectInvoices == null) {
      return [];
    }
    const companyInvoice = baseProject.projectInvoices.find(
      i => i.company != null && i.company.id === invoice.company.id
    );
    if (companyInvoice == null || companyInvoice.priceLines == null) {
      return [];
    }
    let toReturn = companyInvoice.priceLines.filter(
      pl => pl.override === OVERRIDES.REPO_PRICE.value
    );
    toReturn.forEach(pl => {
      const index = this.getIndexOfProduct(project, pl.product);
      if (index > 0) {
        pl.displaySuffix = 'bord #' + (index + 1);
      }
    });
    return toReturn;
  }

  static getIndexOfProduct(project: Project, product: Product): number {
    if (
      project == null ||
      project.products == null ||
      product == null ||
      product.id == null
    ) {
      return -1;
    }
    return project.products.findIndex(p => p.id === product.id);
  }
}
